function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.29955 75.5635C1.83622 79.4778 2.99048 83.2387 5.48215 86.6546C9.96289 92.7965 16.9608 96.7405 23.5201 100.28C34.2108 106.047 60.8227 114.749 61.3764 130.12H62.1601V120.963C61.5681 104.475 51.9379 96.8343 37.9675 89.5041C30.6416 85.658 22.9579 82.3315 16.0153 77.7954C12.906 75.7637 9.88196 73.5106 7.369 70.7506C6.04011 69.2939 4.839 67.752 3.89344 66.0143C3.73585 65.7246 3.59529 65.4009 3.459 65.0644C2.999 66.125 2.20678 68.1865 1.69992 70.4481C1.31659 72.1518 1.09511 73.9663 1.29529 75.555L1.29955 75.5635Z",
  fill: "url(#paint0_linear_3051_726)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.88341 59.9235C9.31971 57.1294 12.2501 54.8507 15.321 52.7935C22.1997 48.185 29.8536 44.8457 37.171 41.0337C51.4054 33.6141 61.5553 26.0411 62.1601 9.16167V0H61.3764C60.8269 15.3589 34.1853 24.1031 23.5073 29.8319C16.9651 33.3415 9.9373 37.3367 5.4736 43.453C0.818229 49.8419 0.81397 57.4531 0.818229 65.0474C0.818229 68.5954 0.831007 72.1391 1.29953 75.5635C0.826748 71.8707 2.65823 66.9257 3.46323 65.0687C3.60378 64.7237 3.7486 64.3872 3.91045 64.0891C4.73675 62.5728 5.75045 61.2141 6.88341 59.915V59.9235Z",
  fill: "url(#paint2_linear_3051_726)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5449 94.3C10.1119 91.868 7.4797 89.3678 5.49914 86.6546C3.29711 83.6391 1.981 80.1848 1.35063 75.785C1.14618 74.3794 1.04822 73.0761 1.04822 71.7983C1.04822 68.9531 1.88303 66.6446 2.70081 64.7663C2.86266 64.3531 3.02025 64.0039 3.18211 63.7143C3.96581 62.2789 4.94118 60.9074 6.25303 59.4039C8.41674 56.925 11.1469 54.6122 14.844 52.1376C19.8316 48.7941 25.2834 46.0852 30.5564 43.47C32.6136 42.4478 34.7219 41.4 36.7706 40.3352C51.9038 32.447 61.5979 24.8102 62.1601 9.14463L62.143 0H62.1047L62.126 9.15741C61.5467 25.2191 52.5256 33.005 37.1369 41.0294C35.0797 42.0985 32.9671 43.1506 30.9227 44.1643C25.6582 46.7794 20.2277 49.4756 15.2827 52.7893C11.6453 55.2256 8.96192 57.4915 6.84507 59.9193C5.57155 61.3844 4.626 62.7048 3.86785 64.0933C3.72303 64.3531 3.57822 64.6768 3.42488 65.0687C2.63692 66.8874 1.67859 69.6943 1.67859 72.3946C1.67859 73.4381 1.61896 74.3411 1.84896 75.9426C2.46229 80.2104 3.84655 83.9074 5.96766 86.8165C7.89711 89.4572 10.1843 91.9191 13.5449 94.3Z",
  fill: "url(#paint3_linear_3051_726)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.8976 66.0185C4.04242 66.2869 4.20853 66.5509 4.37038 66.815C4.17871 66.4956 3.98279 66.1718 3.8252 65.8822L3.8976 66.0185Z",
  fill: "url(#paint4_linear_3051_726)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M62.1601 120.967C61.5851 104.969 52.8536 97.3198 37.9675 89.5083C35.7612 88.3498 33.4868 87.2211 31.289 86.1307L31.1825 86.0796C26.097 83.5581 20.8368 80.9515 16.0196 77.7996C12.2075 75.308 9.54548 73.1357 7.37326 70.7548C6.11678 69.3791 5.15419 68.1056 4.37048 66.8193C5.24363 68.2802 6.40641 69.9668 7.68419 71.3681C9.899 73.8002 12.5909 75.9341 16.4583 78.4641C21.3181 81.6372 25.7264 84.2524 30.846 86.7867L30.9397 86.8335C33.1375 87.9239 35.4077 89.0483 37.6055 90.2026C52.2403 97.8778 60.8184 105.378 61.3807 120.98L61.3636 129.733V130.125H62.1644V129.733H62.1473L62.1644 120.967H62.1601Z",
  fill: "url(#paint5_linear_3051_726)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M61.304 45.77C60.7801 60.4005 36.0892 69.0341 25.8158 74.3667C11.5729 81.7565 1.42305 89.3933 0.818237 106.251V115.409H1.60194C2.12583 100.783 26.8168 92.1448 37.0901 86.8122C51.333 79.4224 61.4786 71.7813 62.0834 54.9274V45.77H61.2997H61.304Z",
  fill: "url(#paint6_linear_3051_726)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.61891 115.409H0.835205V115.017C1.63595 102.508 19.1245 94.3852 30.6926 89.01C32.9756 87.9494 35.0711 86.9783 36.728 86.1137C51.8611 78.2596 61.5382 70.6356 62.1004 54.9104L62.0834 45.7657H62.0663L62.0834 54.9232C61.5041 71.0487 52.483 78.8219 37.09 86.808C35.4161 87.6769 33.3121 88.6565 31.0845 89.6915C19.6228 95.0156 2.38983 103.019 1.61891 115.038V115.405V115.409Z",
  fill: "url(#paint7_linear_3051_726)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M128.984 51.0983L127.744 53.5304C127.182 53.2791 121.824 50.7917 115.793 50.7917C104.344 50.7917 95.9913 59.817 95.9913 70.0946C95.9913 80.3722 104.08 89.3848 115.23 89.3848C119.213 89.3848 124.196 88.3328 128.805 84.2822V73.3913H116.474V70.6526H131.722V85.4067C126.189 90.8159 120.58 92.3791 115.23 92.3791C102.525 92.3791 92.7585 82.4806 92.7585 70.0946C92.7585 57.7087 102.712 47.8102 115.486 47.8102C119.962 47.8102 125.129 49.1731 128.988 51.0983H128.984Z",
  fill: "#A70E13"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M143.55 59.5657L144.108 65.6693C145.855 61.4313 149.837 59.5061 154.445 59.5061V62.8028C149.092 62.8028 144.3 65.6096 144.3 72.3946V91.8807H141.191V59.57H143.555L143.55 59.5657Z",
  fill: "#A70E13"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M164.902 59.5019V78.4854C164.902 85.083 167.645 89.3763 175.482 89.3763C181.155 89.3763 186.006 84.5932 186.006 78.7963V59.4976H189.12V91.868H186.756L186.258 85.577C184.017 90.1813 179.724 92.362 174.992 92.362C166.022 92.362 161.788 87.4426 161.788 78.9113V59.4933H164.906L164.902 59.5019Z",
  fill: "#A70E13"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M231.389 75.6913C231.389 84.525 225.098 92.3705 215.753 92.3705C210.531 92.3705 204.986 89.6957 203.056 84.5974V102.456H199.939V59.5018H202.371L202.873 67.0322C205.361 61.2993 211.085 58.9993 215.749 58.9993C224.847 58.9993 231.385 66.5296 231.385 75.6913H231.389ZM202.75 75.6913C202.75 83.6561 208.346 89.568 215.451 89.568C222.555 89.568 228.271 83.4091 228.271 75.6913C228.271 67.9735 222.67 61.8018 215.451 61.8018C208.231 61.8018 202.75 67.9096 202.75 75.6913Z",
  fill: "#A70E13"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M254.598 59.0035C263.815 59.0035 271.221 66.2911 271.221 75.6955C271.221 85.1 263.815 92.3748 254.598 92.3748C245.381 92.3748 238.106 84.968 238.106 75.6955C238.106 66.4231 245.508 59.0035 254.598 59.0035ZM241.211 75.6955C241.211 83.2898 247.123 89.5722 254.598 89.5722C262.073 89.5722 268.108 83.2898 268.108 75.6955C268.108 68.1013 262.136 61.8061 254.598 61.8061C247.059 61.8061 241.211 67.9693 241.211 75.6955Z",
  fill: "#A70E13"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M310.313 48.3V56.3926H288.148V67.1004H307.016V74.9459H288.148V91.8765H279.429V48.3H310.313Z",
  fill: "#ED1C24"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M324.309 46.3067V83.0982C324.309 83.9074 324.752 84.2183 325.438 84.2183C326.315 84.2183 327.12 84.1587 328.428 84.0352V90.8117C328.176 91.0076 324.811 91.8765 322.196 91.8765C317.907 91.8765 315.786 89.0739 315.786 85.2789V46.3067H324.309Z",
  fill: "#ED1C24"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M348.28 58.88C358.302 58.88 363.153 66.6574 363.153 75.2526C363.153 77.4333 362.847 78.988 362.847 78.988H341.116C341.495 83.5965 345.477 85.3385 349.341 85.3385C353.204 85.3385 356.373 84.3461 358.489 83.4091L361.347 89.6957C358.11 91.5528 353.51 92.4941 349.149 92.4941C339.37 92.4941 332.214 85.8965 332.214 75.998C332.214 66.0994 338.684 58.88 348.276 58.88H348.28ZM355.061 73.008C354.882 69.46 353.51 66.3507 348.774 66.3507C344.724 66.3507 341.81 68.655 340.992 73.008H355.061Z",
  fill: "#ED1C24"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M377.281 59.5018V78.4854C377.281 82.2889 379.215 84.2737 383.385 84.2737C386.805 84.2737 389.608 82.5359 389.608 78.6131V59.5018H398.318V91.8722H391.656L390.596 88.1965C388.479 91.0033 385.438 92.4941 381.387 92.4941C372.988 92.4941 368.699 87.5789 368.699 78.9198V59.5018H377.281Z",
  fill: "#ED1C24"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M412.885 59.817L414.005 64.9239C415.994 60.8137 419.359 59.5061 425.087 59.5061V68.3441H424.027C418.541 68.3441 414.622 70.4609 414.622 77.4376V91.8807H406.036V59.8213H412.88L412.885 59.817Z",
  fill: "#ED1C24"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M435.416 59.5018L443.389 82.8468H443.577L451.789 59.5018H460.818L446.933 93.9252C444.51 99.9009 442.141 102.452 436.851 102.452C434.602 102.452 432.302 102.141 429.875 101.392L431.374 93.6143C432.486 93.8017 435.173 94.2318 436.596 94.1765C437.908 94.1765 438.521 92.9285 438.968 91.6848L426.386 59.4976H435.416V59.5018Z",
  fill: "#ED1C24"
});
var _ref20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3051_726",
  x1: 1.22289,
  y1: 97.5967,
  x2: 62.1601,
  y2: 97.5967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#540304"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#79090C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#980F13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#AF1218"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#C0151C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#CA171E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#CE181F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CA171E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#C0151C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#AF1218"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#980F13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#79090C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#540304"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E0000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3051_726",
  x1: 21.5523,
  y1: 78.2426,
  x2: 35.0584,
  y2: 102.273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E0000",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#230000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E0000",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_3051_726",
  x1: 0.818229,
  y1: 37.7839,
  x2: 62.1601,
  y2: 37.7839,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ED1F25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ED2929"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#EE3A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#F0513B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F15B40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#F0573E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#F04D3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EF3C32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ED2528"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3051_726",
  x1: 5.3671,
  y1: 73.9493,
  x2: 21.9995,
  y2: 60.2174,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED1B34"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_3051_726",
  x1: 3.8252,
  y1: 66.3507,
  x2: 4.37038,
  y2: 66.3507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1B34"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_3051_726",
  x1: 4.37048,
  y1: 98.4698,
  x2: 62.1601,
  y2: 98.4698,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1B34"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_3051_726",
  x1: 0.818237,
  y1: 80.5894,
  x2: 62.0834,
  y2: 80.5894,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ED1F25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ED2929"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#EE3A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#F0513B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F15B40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#F0573E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#F04D3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EF3C32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ED2528"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_3051_726",
  x1: 1.77224,
  y1: 98.095,
  x2: 32.4389,
  y2: 80.2402,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED1B34"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3051_726"
}, /*#__PURE__*/React.createElement("rect", {
  width: 460,
  height: 130.125,
  fill: "white",
  transform: "translate(0.818237)"
})));
const SvgLogoFleury = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 131,
    viewBox: "0 0 461 131",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_726)"
  }, _ref2, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.29955 75.5635C1.83622 79.4778 2.99048 83.2387 5.48215 86.6546C9.96289 92.7965 16.9608 96.7405 23.5201 100.28C34.2108 106.047 60.8227 114.749 61.3764 130.12H62.1601V120.963C61.5681 104.475 51.9379 96.8343 37.9675 89.5041C30.6416 85.658 22.9579 82.3315 16.0153 77.7954C12.906 75.7637 9.88196 73.5106 7.369 70.7506C6.04011 69.2939 4.839 67.752 3.89344 66.0143C3.73585 65.7246 3.59529 65.4009 3.459 65.0644C2.999 66.125 2.20678 68.1865 1.69992 70.4481C1.31659 72.1518 1.09511 73.9663 1.29529 75.555L1.29955 75.5635Z",
    fill: "url(#paint1_linear_3051_726)"
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19), _ref20);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoFleury, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logoFleury.e57a88a7.svg";
export { ForwardRef as ReactComponent };